// extracted by mini-css-extract-plugin
module.exports = {"wizardContainer":"_3nkjpjzSQsXn_qSPgKVXCT","lookUpHeaderTitle":"UL6QU8RRCjGui75y04E-Y","lookUpHeaderStatus":"_1lr4BJNg0K1fhz2sjJilbM"};